import moment from 'moment';
import { getDaysSinceWeekStart } from '@s20/common/util/date';
import { useCalendarWeekStartsOn } from '@s20/hooks/tenant.hooks';
import JobCard from './JobCard';

const CalendarEvent = ({ event }) => {
    const weekStartsOn = useCalendarWeekStartsOn();
    const chipPosition = getDaysSinceWeekStart(event.start, weekStartsOn) === 0 ? 'right' : 'left';
    const job = event.resource || event;

    // Check if this job is from a previous day (for gray background)
    const today = moment().startOf('day');
    const jobDate = moment(event.start).startOf('day');
    const isPreviousDay = jobDate.isBefore(today);

    return (
        <JobCard
            job={job}
            onClick={() => {}}
            chipPosition={chipPosition}
            isPreviousDay={isPreviousDay}
            currentView="month"
        />
    );
};

export default CalendarEvent;